import { FC, Suspense } from 'react'
import { Outlet } from '@tanstack/react-router'
import cn from 'classnames'
import { Seo } from 'components'
import { Logo } from 'components/extend/Logo'
import { IconSpinner } from 'components/IconSpinner'
import { Link } from 'components/Link'
import { MainWarning } from 'components/MainWarning'
import { LANDING_ROOT_LINK, SUPPORT_TEL, SUPPORT_TEL_FORMATTED } from 'constants/links'
import * as features from 'utils/feature'

const AuthLayout: FC = () => {
  const currentYear = new Date().getFullYear()

  return (
    <div
      className={cn(
        'flex min-h-screen w-full flex-col bg-background',
        features.newYearLogo && "bg-[url('assets/new-year-pattern.svg')]"
      )}
    >
      <Seo
        description="Личный кабинет пользователя сервиса QP5 Express."
        title="Вход в личный кабинет – сборные перевозки QP5 Express"
      />
      <MainWarning />
      {features.devFeatures && (
        <div className="fixed left-1 top-10 z-notice flex flex-col gap-y-2 bg-surface p-1 opacity-[0.8]">
          <Link to="/order/create">Гость создание заказа</Link>
          <Link to="/order-yarche-guest/create">Гость создание посылки</Link>
        </div>
      )}
      <div className="mx-auto mt-8 flex items-center">
        <Logo isNative isNewYear={features.newYearLogo} link={LANDING_ROOT_LINK} type="adaptive" />
      </div>
      <div className="flex flex-grow flex-col items-center">
        <Suspense fallback={<IconSpinner size="lg" />}>
          <Outlet />
        </Suspense>
      </div>
      <div className="flex flex-none flex-col">
        <div className="mx-auto flex min-h-[72px] max-w-screen-3lg flex-col flex-wrap items-center justify-center p-6 text-body-md">
          <span className="text-center text-on-background">
            Бесплатная горячая линия:{' '}
            <Link rel="noreferrer" to={`tel:${SUPPORT_TEL}`}>
              {SUPPORT_TEL_FORMATTED}
            </Link>
          </span>
          <span className="mt-1 text-center text-on-surface-variant">
            © 2021—{currentYear} АО «Корса» 634034, г. Томск, пер. Инструментальный 51а, каб. 414
          </span>
        </div>
      </div>
    </div>
  )
}

export default AuthLayout
